import { RequestState } from '../../../../types/request-state.model';
import { Listing } from '../../../../types/listing.model';
import { ListingFilter } from '../../../../types/listing-filter.model';

const PREFIX = '[Listing]';

export const REFRESH_LISTING = `${PREFIX} REFRESH`;
export const REFRESH_LISTING_SUCCESS = `${PREFIX} REFRESH_SUCCESS`;
export const REFRESH_LISTING_FAIL = `${PREFIX} REFRESH_FAIL`

export const DELETE_LISING = `${PREFIX} DELETE`;
export const DELETE_LISTING_SUCCESS = `${PREFIX} DELETE_LISTING_SUCCESS`
export const DELETE_LISTING_FAIL = `${PREFIX} DELETE_LISTING_FAIL`

export const EXPIRE_LISTING = `${PREFIX} EXPIRE`
export const EXPIRE_LISTING_SUCCESS = `${PREFIX} EXPIRE_SUCCESS`
export const EXPIRE_LISTING_FAIL = `${PREFIX} EXPIRE_FAIL`

export const GET_LISTING_DATA = `${PREFIX} GET_LISTING_DATA`;
export const GET_LISTING_DATA_SUCCESS = `${PREFIX} GET_LISTING_DATA_SUCCESS`;
export const GET_LISTING_DATA_FAIL = `${PREFIX} GET_LISTING_DATA_FAIL`;

export const GET_LISTING_DETAIL = `${PREFIX} GET_LISTING_DETAIL`;
export const GET_LISTING_DETAIL_SUCCESS = `${PREFIX} GET_LISTING_DETAIL_SUCCESS`;
export const GET_LISTING_DETAIL_FAIL = `${PREFIX} GET_LISTING_DETAIL_FAIL`;

export const POST_PROPERTY = `${PREFIX} POST_PROPERTY`;
export const POST_PROPERTY_SUCCESS = `${PREFIX} POST_PROPERTY_SUCCESS`;
export const POST_PROPERTY_FAIL = `${PREFIX} POST_PROPERTY_FAIL`;

export const SAVE_AS_DRAFT = `${PREFIX} SAVE_AS_DRAFT`;
export const SAVE_AS_DRAFT_SUCCESS = `${PREFIX} SAVE_AS_DRAFT_SUCCESS`;
export const SAVE_AS_DRAFT_FAIL = `${PREFIX} SAVE_AS_DRAFT_FAIL`;

export const GENERATE_DESCRIPTION_PREFILL = `${PREFIX} GENERATE_DESCRIPTION_PREFILL`;
export const GENERATE_DESCRIPTION_PREFILL_SUCCESS = `${PREFIX} GENERATE_DESCRIPTION_PREFILL_SUCCESS`;
export const GENERATE_DESCRIPTION_PREFILL_FAIL = `${PREFIX} GENERATE_DESCRIPTION_PREFILL_FAIL`;

export const UPDATE_PROPERTY = `${PREFIX} UPDATE_PROPERTY`;
export const UPDATE_PROPERTY_SUCCESS = `${PREFIX} UPDATE_PROPERTY_SUCCESS`;
export const UPDATE_PROPERTY_FAIL = `${PREFIX} UPDATE_PROPERTY_FAIL`;

export const RESET_POST_PROPERTY = `${PREFIX} RESET_POST_PROPERTY`;
export const CLEAR_FOCUSED_LISTING = `${PREFIX} CLEAR_FOCUSED_LISTING`;

export const GET_API_PROPERTY = `${PREFIX} GET_API_PROPERTY`;
export const GET_API_PROPERTY_SUCCESS = `${PREFIX} GET_API_PROPERTY_SUCCESS`;
export const GET_API_PROPERTY_FAIL = `${PREFIX} GET_API_PROPERTY_FAIL`;

export interface ListingState {
  gridStage?: string;
  getListingDataState?: RequestState;
  getListingStatus?: string;
  gridFilters?: ListingFilter;
  groupProfile?: string;

  listings?: Listing[];
  totalListings?: number;
  getListingDetailState?: RequestState;

  focusedPropertyKey?: string;
  focusedListing?: Listing;

  apiProperty?: Listing;
  descriptionPrefill?: string;

  listingToUpdate?: Listing;

  submitPropertyStatus?: RequestState;
  submitDraftStatus?: RequestState;
  updatePropertyStatus?: RequestState;
  retrieveDescPrefillStatus?: RequestState;
  getApiPropertyStatus?: RequestState;
  deletePropertyStatus?: RequestState;
  
  refreshListingStatus?: RequestState;
  expireListingStatus?: RequestState

  reason?: string;
  ppsqm?: ListingPpsqm;
}

export interface ListingAction {
  type: string,
  payload?: ListingState
}

export interface ListingPpsqm {
  averagePricePerSqm: number;
  averageAreaSqm: number;
  averagePrice: number;
}
